var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoRef",attrs:{"controls":"","playsinline":"","autoplay":_vm.isAutoplay}},[_c('source',{attrs:{"src":_vm.finalHlsUrl,"type":"hlsType"}})])}
var staticRenderFns = []

export { render, staticRenderFns }